// extracted by mini-css-extract-plugin
export var actions = "_qz-4";
export var item = "_qz-1";
export var price = "_qz-3";
export var quantity = "_qz-2";
export var table = "_qz-0";